module.exports = __webpack_public_path__ + "static/media/ww.ec07030e.png";